var map = {
	"./": 20306,
	"./api/admin": 40717,
	"./api/admin.js": 40717,
	"./api/article": 88203,
	"./api/article.js": 88203,
	"./api/auth": 66312,
	"./api/auth.js": 66312,
	"./api/brand": 45027,
	"./api/brand.js": 45027,
	"./api/common": 97700,
	"./api/common.js": 97700,
	"./api/config": 22201,
	"./api/config.js": 22201,
	"./api/extenAuth": 4887,
	"./api/extenAuth.js": 4887,
	"./api/goods": 95398,
	"./api/goods.js": 95398,
	"./api/login": 8938,
	"./api/login.js": 8938,
	"./api/message": 6846,
	"./api/message.js": 6846,
	"./api/notice": 86234,
	"./api/notice.js": 86234,
	"./api/salesman": 33946,
	"./api/salesman.js": 33946,
	"./api/storage": 94084,
	"./api/storage.js": 94084,
	"./api/user": 90850,
	"./api/user.js": 90850,
	"./index": 20306,
	"./index.js": 20306
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2521;